import { Box, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const Item = styled(Box)(({ theme }) => ({
    color: theme.palette.white.main,
    p: 1,
    borderRadius: 1,
    fontSize: 19,
    fontWeight: '700',
    minHeight: '60px',
}));

const DayPaper = styled(Paper, {
    shouldForwardProp: prop => prop !== 'previous' && prop !== 'isToday',
    name: 'DayPaper',
    overridesResolver: (props, styles) => [
        props.previous === false && styles.paperNoPad,
        props.previous === true && props.isToday === true && styles.paperToday,
        props.previous === true &&
            props.isToday === false &&
            styles.paperDisabled,
    ],
})(({ theme }) => ({}));

const NumberTypography = styled(Typography, {
    shouldForwardProp: prop => prop !== 'isToday',
    name: 'numberTypography',
    slot: 'Root',
    overridesResolver: (props, styles) => [
        styles.root,
        props.isToday === true && styles.calNumberToday,
    ],
})(({ theme }) => ({}));

const DayItemComponentEmpty = props => {
    const disabled = props.previous || props.disabled;
    return (
        <Item key={props.key}>
            {!disabled ? (
                <DayPaper
                    previous={disabled}
                    isToday={props.isToday}
                    onClick={props.toggleDrawer(
                        props.direction,
                        props.tempDay,
                        true,
                        props.type
                    )}
                    data-cy="day-empty"
                >
                    <NumberTypography
                        isToday={props.isToday}
                        align="left"
                        color="textPrimary"
                    >
                        {props.formattedDate}
                    </NumberTypography>
                </DayPaper>
            ) : (
                <DayPaper previous={disabled} isToday={props.isToday}>
                    <NumberTypography
                        isToday={props.isToday}
                        align="left"
                        color="textPrimary"
                    >
                        {props.formattedDate}
                    </NumberTypography>
                </DayPaper>
            )}
        </Item>
    );
};
export default DayItemComponentEmpty;
